import { AdminActionTypes } from "./admin-types";

const INITIAL_STATE = {

    selectedTabAdmin: 'Users',

    allUsers: null,
    isFetchingUsers: false,
    isAllFetchingUsers: false,
    errorMessage: '',
    users: null,
    searchQuery: {pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []},
    searchQueryUsers: {pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []},
    numUsers: 0,
    selectedUsers: [],

    allRoles: null,
    searchRolesQuery: {pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []},
    isFetchingRoles: false,
    isFetchingAllRoles: false,
    isFetchingRolesOnPage: false,
    roles: null,
    rolesOnPage: null,
    numRoles: 0,
    selectedRoles: [],

//deprecate department
    allDepartments: null,
    searchDepartmentsQuery: {pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []},
    isFetchingDepartments: false,
    isFetchingAllDepartments: false,
    departments: null,
    departmentsOnPage: null,
    numDepartments: 0,
    selectedDepartments: [],


    allLogs: null,
    searchLogsQuery: {pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []},
    isFetchingLogs: false,
    isFetchingAllLogs: false,
    logs: null,
    numLogs: 0,
    selectedLogs: [],

    // templates
    allTemplates: null,
    searchTemplatesQuery: {userID: 1, pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []},
    isFetchingTemplates: false,
    isFetchingAllTemplates: false,
    isFetchingTemplatesOnPage: false,
    templates: null,
    templatesOnPage: null,
    numTemplates: 0,
    selectedTemplates: [],

    // template Tasks
    allTemplateTasks: null,
    searchTemplateTasksQuery: {projectID: 1, pageSize: 10, pageNumber: 1, sortDesc: false, sortBy: "name",  filters: []},
    isFetchingTemplateTasks: false,
    isFetchingAllTemplateTasks: false,
    isFetchingTemplateTasksOnPage: false,
    templateTasks: null,
    templateTasksOnPage: null,
    numTemplateTasks: 0,
    selectedTemplateTasks: [],
}

const adminReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        /// USERS

        case AdminActionTypes.FETCH_USERS_START:
            return {
                ...state,
                isFetchingUsers: true
            }
        case AdminActionTypes.FETCH_USERS_SUCCESS:
            return {
                ...state,
                isFetchingUsers: false,
                users: action.payload[0],
                numUsers: action.payload[1]
            }
        case AdminActionTypes.FETCH_USERS_FAILURE:
            return {
                ...state,
                isFetchingUsers: false,
                errorMessage: action.payload
            }

        case AdminActionTypes.FETCH_ALL_USERS_START:
            return {
                ...state,
                isFetchingAllUsers: true
            }
        case AdminActionTypes.FETCH_ALL_USERS_SUCCESS:
            return {
                ...state,
                isFetchingAllUsers: false,
                allUsers: action.payload,
                //numUsers: action.payload.length
            }
        case AdminActionTypes.FETCH_ALL_USERS_FAILURE:
            return {
                ...state,
                isFetchingAllUsers: false,
                errorMessage: action.payload
            }
        
        case AdminActionTypes.SET_USERS_ON_PAGE: //setting the users that are displayed on the page
            return {
                ...state,
                usersOnPage: action.payload,
                isFetchingUsersOnPage: false
            }        
        case AdminActionTypes.SET_SEARCH_QUERY: 
            return {
                ...state,
                searchQuery: action.payload
            }

        case AdminActionTypes.SET_SEARCH_QUERY_USERS: 
            return {
                ...state,
                searchQueryUsers: action.payload
            }


        case AdminActionTypes.ADD_SELECTED_USER:
            return {
                ...state,
                selectedUsers: [
                    ...state.selectedUsers,
                    action.payload
                ],
            }
        case AdminActionTypes.DELETE_SELECTED_USER:
            return {
                ...state,
                selectedUsers: [
                    ...state.selectedUsers.slice(0, state.selectedUsers.indexOf(action.payload)),
                    ...state.selectedUsers.slice(state.selectedUsers.indexOf(action.payload) + 1)
                ],
            }
        case AdminActionTypes.SET_SELECTED_USER:
            return {
                ...state,
                selectedUsers: action.payload
            }

        
        case AdminActionTypes.SET_ADMIN_TAB:
            return {
                ...state,
                selectedTabAdmin: action.payload
            }
    
        /// ROLES

        case AdminActionTypes.FETCH_ROLES_START: 
            return{
                ...state,
                isFetchingRoles: true
            }

        case AdminActionTypes.FETCH_ROLES_SUCCESS:
            return {
                ...state,
                isFetchingRoles: false,
                roles: action.payload[0],
                numRoles: action.payload[1]
            }
        
        case AdminActionTypes.FETCH_ROLES_FAILURE:
            return {
                ...state,
                isFetchingRoles: false,
                errorMessage: action.payload
            }
        case AdminActionTypes.SET_ROLES_ON_PAGE: //setting the roles that are displayed on the page
            return {
                ...state,
                rolesOnPage: action.payload
            }

        case AdminActionTypes.SET_SEARCH_ROLES_QUERY:
            return {
                ...state,
                searchRolesQuery: action.payload
            }

        case AdminActionTypes.ADD_SELECTED_ROLE:
            return {
                ...state,
                selectedRoles: [
                    ...state.selectedRoles,
                    action.payload
                ],
            }

        case AdminActionTypes.DELETE_SELECTED_ROLE:
            return {
                ...state,
                selectedRoles: [
                    ...state.selectedRoles.slice(0, state.selectedRoles.indexOf(action.payload)),
                    ...state.selectedRoles.slice(state.selectedRoles.indexOf(action.payload) + 1)
                ],
            }
        case AdminActionTypes.SET_SELECTED_ROLE:
            return {
                ...state,
                selectedRoles: action.payload
            }


        /// DEPARTMENTS
  //deprecate department
        case AdminActionTypes.FETCH_DEPARTMENTS_START:
            return {
                ...state,
                isFetchingDepartments: true
            }

        case AdminActionTypes.SET_ALL_DEPARTMENTS:
            return {
                ...state,
                isFetchingAllDepartments: false,
                departments: action.payload
            }
        // case AdminActionTypes.FETCH_DEPARTMENTS_START:
        //     return{
        //         ...state,
        //         isLoadingDepartments: true
        //     }

        case AdminActionTypes.FETCH_DEPARTMENTS_SUCCESS:
            return {
                ...state,
                isFetchingDepartments: false,
                departments: action.payload[0],
                numDepartments: action.payload[1]
            }
        
        case AdminActionTypes.FETCH_DEPARTMENTS_FAILURE:
            return {
                ...state,
                isFetchingDepartments: false,
                errorMessage: action.payload
            }
        case AdminActionTypes.SET_DEPARTMENTS_ON_PAGE: //setting the roles that are displayed on the page
            return {
                ...state,
                departmentsOnPage: action.payload
            }

        case AdminActionTypes.SET_SEARCH_DEPARTMENTS_QUERY:
            return {
                ...state,
                searchDepartmentsQuery: action.payload
            }
        case AdminActionTypes.ADD_SELECTED_DEPARTMENT:
            return {
                ...state,
                selectedDepartments: [
                    ...state.selectedDepartments,
                    action.payload
                ],
            }
        case AdminActionTypes.DELETE_SELECTED_DEPARTMENT:
                return {
                    ...state,
                    selectedDepartments: [
                        ...state.selectedDepartments.slice(0, state.selectedDepartments.indexOf(action.payload)),
                        ...state.selectedDepartments.slice(state.selectedDepartments.indexOf(action.payload) + 1)
                    ],
                }
        case AdminActionTypes.SET_SELECTED_DEPARTMENT:
                return {
                    ...state,
                    selectedDepartments: action.payload
                }

        /// LOGS

        case AdminActionTypes.FETCH_LOGS_START:
            return {
                ...state,
                isFetchingLogs: true
            }
        case AdminActionTypes.FETCH_LOGS_SUCCESS:
            return {
                ...state,
                isFetchingLogs: false,
                logs: action.payload[0],
                numLogs: action.payload[1]
            }
        case AdminActionTypes.FETCH_LOGS_FAILURE:
            return {
                ...state,
                isFetchingLogs: false,
                errorMessage: action.payload
            }

        case AdminActionTypes.SET_SEARCH_LOGS_QUERY:
            return {
                ...state,
                searchLogsQuery: action.payload
            }
        
        case AdminActionTypes.ADD_SELECTED_LOG:
            return {
                ...state,
                selectedLogs: [
                    ...state.selectedLogs,
                    action.payload
                ],
            }

        case AdminActionTypes.DELETE_SELECTED_LOG:
            return {
                ...state,
                selectedLogs: [
                    ...state.selectedLogs.slice(0, state.selectedLogs.indexOf(action.payload)),
                    ...state.selectedLogs.slice(state.selectedLogs.indexOf(action.payload) + 1)
                ],
            }
        case AdminActionTypes.SET_SELECTED_LOG:
            return {
                ...state,
                selectedLogs: action.payload
            }

        // Templates

        case AdminActionTypes.FETCH_TEMPLATES_START: 
            return{
                ...state,
                isFetchingTemplates: true
            }

        case AdminActionTypes.FETCH_TEMPLATES_SUCCESS:
            return {
                ...state,
                isFetchingTemplates: false,
                templates: action.payload[0],
                numTemplates: action.payload[1]
            }
        
        case AdminActionTypes.FETCH_TEMPLATES_FAILURE:
            return {
                ...state,
                isFetchingTemplates: false,
                errorMessage: action.payload
            }
        case AdminActionTypes.SET_TEMPLATES_ON_PAGE: //setting the roles that are displayed on the page
            return {
                ...state,
                templatesOnPage: action.payload
            }

        case AdminActionTypes.SET_SEARCH_TEMPLATES_QUERY:
            return {
                ...state,
                searchTemplatesQuery: action.payload
            }

        case AdminActionTypes.ADD_SELECTED_TEMPLATE:
            return {
                ...state,
                selectedTemplates: [
                    ...state.selectedTemplates,
                    action.payload
                ],
            }

        case AdminActionTypes.DELETE_SELECTED_TEMPLATE:
            return {
                ...state,
                selectedTemplates: [
                    ...state.selectedTemplates.slice(0, state.selectedTemplates.indexOf(action.payload)),
                    ...state.selectedTemplates.slice(state.selectedTemplates.indexOf(action.payload) + 1)
                ],
            }
        case AdminActionTypes.SET_SELECTED_TEMPLATE:
            return {
                ...state,
                selectedTemplates: action.payload
            }
        
        // Template Tasks

        case AdminActionTypes.FETCH_TEMPLATE_TASKS_START: 
            return{
                ...state,
                isFetchingTemplateTasks: true
            }

        case AdminActionTypes.FETCH_TEMPLATE_TASKS_SUCCESS:
            return {
                ...state,
                isFetchingTemplateTasks: false,
                templateTasks: action.payload[0],
                numTemplateTasks: action.payload[1]
            }
        
        case AdminActionTypes.FETCH_TEMPLATE_TASKS_FAILURE:
            return {
                ...state,
                isFetchingTemplateTasks: false,
                errorMessage: action.payload
            }
        case AdminActionTypes.SET_TEMPLATE_TASKS_ON_PAGE: //setting the tasks that are displayed on the page
            return {
                ...state,
                templateTasksOnPage: action.payload
            }

        case AdminActionTypes.SET_SEARCH_TEMPLATE_TASKS_QUERY:
            return {
                ...state,
                searchTemplateTasksQuery: action.payload
            }

        case AdminActionTypes.ADD_SELECTED_TEMPLATE_TASKS:
            return {
                ...state,
                selectedTemplateTasks: [
                    ...state.selectedTemplateTasks,
                    action.payload
                ],
            }

        case AdminActionTypes.DELETE_SELECTED_TEMPLATE_TASKS:
            return {
                ...state,
                selectedTemplateTasks: [
                    ...state.selectedTemplateTasks.slice(0, state.selectedTemplateTasks.indexOf(action.payload)),
                    ...state.selectedTemplateTasks.slice(state.selectedTemplateTasks.indexOf(action.payload) + 1)
                ],
            }
        case AdminActionTypes.SET_SELECTED_TEMPLATE_TASKS:
            return {
                ...state,
                selectedTemplateTasks: action.payload
            } 


        default:
            return state;
    }
}

export default adminReducer;